import type { ScrollAxis } from "./scroll-box-axes"

export interface PixelSpan {
  startPx: number
  endPx: number
}

export function rectSpan(rect: DOMRectReadOnly, axis: ScrollAxis): PixelSpan {
  return { startPx: rect[axis.rectStart], endPx: rect[axis.rectEnd] }
}

export function crossRectSpan(rect: DOMRectReadOnly, axis: ScrollAxis): PixelSpan {
  return { startPx: rect[axis.crossRectStart], endPx: rect[axis.crossRectEnd] }
}

export function scrollportSpan(element: Element, axis: ScrollAxis): PixelSpan {
  const startPx = element.getBoundingClientRect()[axis.rectStart] + element[axis.clientOffset]
  return { startPx, endPx: startPx + element[axis.clientSize] }
}

export function windowSpan(axis: ScrollAxis): PixelSpan {
  return { startPx: 0, endPx: document.documentElement[axis.clientSize] }
}

export function spanExtentPx(span: PixelSpan): number {
  return span.endPx - span.startPx
}

export function shiftSpan(span: PixelSpan, shiftPx: number): PixelSpan {
  return { startPx: span.startPx + shiftPx, endPx: span.endPx + shiftPx }
}

export function intersectSpans(first: PixelSpan, second: PixelSpan): PixelSpan {
  return { startPx: Math.max(first.startPx, second.startPx), endPx: Math.min(first.endPx, second.endPx) }
}

export function spansOverlap(first: PixelSpan, second: PixelSpan): boolean {
  return first.startPx < second.endPx && second.startPx < first.endPx
}

export function endOverhangPx(span: PixelSpan, bounds: PixelSpan): number {
  return Math.max(0, span.endPx - bounds.endPx)
}

export function startOverhangPx(span: PixelSpan, bounds: PixelSpan): number {
  return Math.max(0, bounds.startPx - span.startPx)
}

export function overhangPx(span: PixelSpan, bounds: PixelSpan): number {
  return Math.max(endOverhangPx(span, bounds), startOverhangPx(span, bounds))
}
